/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const ArrowChevronLeft1 = ({ className }) => {
  return (
    <svg
      className={`arrow-chevron-left-1 ${className}`}
      fill="none"
      height="60"
      viewBox="0 0 60 60"
      width="60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M37.5 47.5L20 30L37.5 12.5"
        stroke="white"
        // stroke="#5F5F60"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
};
